const getDomain = () => {
  const parts = location.hostname.split(".");
  let domain = parts.slice(-2).join(".");
  domain !== "localhost" ? (domain = "." + domain) : "";

  return domain;
};
export default getDomain;
